import { useIsFetching } from "@tanstack/react-query"

import { RISK_ZONES_ROOT_QUERY_KEY } from "./queryKeys"

export function useIsFetchingRiskZones() {
    const isFetchingRiskZones = useIsFetching({ queryKey: [RISK_ZONES_ROOT_QUERY_KEY, "layer"] })

    const isFetching = isFetchingRiskZones

    return isFetching > 0
}